import { render, staticRenderFns } from "./UnderinflationEvents.vue?vue&type=template&id=64c4b541&scoped=true"
import script from "./UnderinflationEvents.vue?vue&type=script&lang=js"
export * from "./UnderinflationEvents.vue?vue&type=script&lang=js"
import style0 from "./UnderinflationEvents.vue?vue&type=style&index=0&id=64c4b541&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c4b541",
  null
  
)

export default component.exports